var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomePc4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2844_23659)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.6665,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "#E1DEF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2844_23659",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2844_23659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 19.3333H16.9998V17.6667H18.6665V15.6667H16.9998V14H14.9998V15.6667H13.3332V17.6667H14.9998V19.3333ZM10.6665 22V14L15.9998 10L21.3332 14V22H10.6665ZM11.9998 20.6667H19.9998V14.6667L15.9998 11.6667L11.9998 14.6667V20.6667Z",
    fill: "#62648F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2844_23659"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.6665,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePc4);
export default __webpack_public_path__ + "static/media/welcome_pc_4.1309498f9e3185f96320a257866e9dfa.svg";
export { ForwardRef as ReactComponent };